import React from 'react';
import { MenuProvider } from './src/context/MenuContext'; // Adjust the path
import { SliderProvider } from './src/context/SliderContext'; // Adjust the path

import './src/assets/scss/main.global.scss';

export const wrapRootElement = ({ element }) => {
  return <MenuProvider><SliderProvider>{element}</SliderProvider></MenuProvider>;
};
